import React from "react";

import { Grid, Typography } from "@mui/material";

import { formatDate } from "@aclymatepackages/formatters";

import HeaderFooterBox from "./HeaderFooterBox";

import { useAccountData } from "../../../helpers/firebase";

const Header = ({ startDate, endDate }) => {
  const [{ branding }] = useAccountData();
  const { logoUrl, secondaryLogoUrl } = branding || {};
  const headerLogoUrl = secondaryLogoUrl || logoUrl;

  return (
    <HeaderFooterBox>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          {headerLogoUrl && <img src={headerLogoUrl} alt="Logo" crossOrigin="anonymous" style={{ height: 50, maxWidth: 300 }} />}
        </Grid>
        <Grid item>
          <Typography variant="body2" color="textPrimary">
            Report Date: {formatDate(new Date())}
          </Typography>
          <Typography variant="body2" color="textPrimary">
            Reporting Period: {formatDate(startDate)} - {formatDate(endDate)}
          </Typography>
        </Grid>
      </Grid>
    </HeaderFooterBox>
  );
};
export default Header;
